import flatpickr from "flatpickr"

document.addEventListener('turbolinks:load', () => {
    $(".datepicker").flatpickr({
        prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.65 25"><defs><style>.cls-2{fill:#808080;}</style></defs><title>previous_arrow</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon class="cls-2" points="0 12.5 21.65 25 21.65 0 0 12.5"/></g></g></svg>',
        nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.65 25"><defs><style>.cls-1{fill:#fff;}</style></defs><title>next_arrow</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon class="cls-1" points="21.65 12.5 0 0 0 25 21.65 12.5"/></g></g></svg>',
        monthSelectorType: 'static'
    })
})